var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$vuetify.breakpoint.mdAndUp ? _c('div', {
    staticClass: "copy_container"
  }, [_vm.isBech32 ? _c('router-link', {
    staticClass: "addr monospace",
    attrs: {
      "to": _vm.internalURL
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.abbrev32[0]))]), _c('span', [_vm._v(_vm._s(_vm.abbrev32[1]))]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.abbrev32[2]))]), _c('span', [_vm._v(_vm._s(_vm.abbrev32[3]))]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.address.substring(_vm.address.length - 5, _vm.address.length)))])]) : _c('a', {
    staticClass: "addr monospace",
    attrs: {
      "href": "".concat(_vm.externalURL)
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.abbrevHex[0]))]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.abbrevHex[1]))]), _c('span', [_vm._v(_vm._s(_vm.abbrevHex[2]))]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.address.substring(_vm.address.length - 5, _vm.address.length)))])]), _c('CopyText', {
    attrs: {
      "value": _vm.address
    }
  })], 1) : _c('div', {
    staticClass: "copy_container"
  }, [_vm.isBech32 ? _c('router-link', {
    staticClass: "addr monospace",
    attrs: {
      "to": _vm.internalURL
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.abbrev32[0]))]), _c('span', [_vm._v(_vm._s(_vm.abbrev32[3]))]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.address.substring(_vm.address.length - 5, _vm.address.length)))])]) : _c('a', {
    staticClass: "addr monospace",
    attrs: {
      "href": "".concat(_vm.externalURL)
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.abbrevHex[0]))]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.address.substring(_vm.address.length - 5, _vm.address.length)))])]), _c('CopyText', {
    attrs: {
      "value": _vm.address
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }